import { prevQuestion } from "./prevQuestion";
const prevQuestionSlug = ({ question, questions }) => {
    const prev = prevQuestion({ question, questions });
    return prev?.metadata.slug;
};
export { prevQuestionSlug };
